import React from 'react'
import { connect } from 'react-redux'
import { getFormValue, hasChangedValues } from '../../public/utility/formValues'

class MaterialDiv extends React.Component {
    state = {
        fatherID: this.props.fatherID || 0,
        id: this.props.id || 0
    }

    componentDidMount = () => {
        const { id } = this.props
        this.handlerInitValue(id, this.state.fatherID)
    }

    handlerInitValue = (id, fatherID) => {
        Tyan.doPostEvent({
            event: 'GetMaterial',
            data: { id, fatherID },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
            }
        })
    }

    handlerSave = () => {
        const { changedValues基本信息, fatherID } = this.state
        const { id } = this.state
        Tyan.doPostEvent({
            event: 'SaveMaterial',
            data: { id, fatherID, changedValues基本信息 },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                this.handlerInitValue(id)
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose, } = this.props
        Tyan.pubForm.showConfirm('确定要删除分类方式？', () =>
            Tyan.doPostEvent({
                event: 'DeleteMaterial',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }))
    }

    handlerClose = () => {
        const { onClose, onSave } = this.props
        if (!this.bChanged()) {
            onSave && onSave()
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '物料名称') && getFormValue(this, '基本信息', '所属分类')
            && getFormValue(this, '基本信息', '资产属性') && getFormValue(this, '基本信息', '单位') && getFormValue(this, '基本信息', '制造商')
    }

    fieldset基本信息 = () => {
        return [
            { _text: '物料代码', minWidth: '45%', disabled: true },
            { _text: '制造商', minWidth: '45%', required: true },
            { _text: '物料名称', minWidth: '45%', required: true },
            { _select: '单位', minWidth: '45%', required: true, editable: true },
            { _radio: '资产属性', minWidth: '45%', required: true },
            { _select: '所属分类', minWidth: '45%', required: true },
            //物料管理-物料信息，资产小类删除
            //2022-8-24
            // { _text: '资产小类', minWidth: '45%', },
            { _radio: '类别', minWidth: '45%', required: true },
            { _text: '规格型号', minWidth: '45%', },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, } = this.props
        const { initValues基本信息, id } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="900"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(MaterialDiv)